import { useQuery } from '@tanstack/react-query';
import { message } from 'antd';
import { apiGet } from 'helpers/ApiHelper';
import { getTranslatedString } from 'helpers/i18n';
import { formatApplicantsData } from '../helpers';

export const useApplication = (applicationId) =>
  useQuery({
    queryKey: ['applications', applicationId],
    queryFn: () =>
      apiGet(`/landlords/application_management/applications/${applicationId}`).then((response) => {
        const applicants = formatApplicantsData(response.application);
        return { ...response.application, applicants };
      }),
    onError: () => message.error(getTranslatedString('unknownError')),
  });
